export default __webpack_public_path__ + "static/media/rec3dhemi.28d044f5.jpg";